import { Pipe, PipeTransform } from '@angular/core';
import { isValidCountryISOCode } from '../core/utilities';

@Pipe({
  name: 'flagEmoji',
  standalone: true,
})
export class FlagEmojiPipe implements PipeTransform {
  // used only by isValidCountryCode as argument to check country code validity, locale should not matter
  private displayNames = new Intl.DisplayNames(['en'], { type: 'region' });

  transform(countryCode: string | undefined): string {
    // 1. Check for valid country code
    if (!countryCode || !isValidCountryISOCode(this.displayNames, countryCode)) {
      return '';
    }

    const upperCaseCode = countryCode.toUpperCase();

    // 2. The offset (0x1F1A5 or 127397) transforms a standard ASCII letter's
    //    code point into its corresponding Regional Indicator Symbol code point.
    const offset = 0x1F1A5;

    // 3. Map each character to its new code point and create the string.
    const codePoints = upperCaseCode
        .split('')
        .map(char => char.charCodeAt(0) + offset);

    return String.fromCodePoint(...codePoints);
  }
}